/* eslint-disable import/no-anonymous-default-export */

import MemberAccountReportTypes from './member-account-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	memberAccountReportSavingsResponse: null,
	memberAccountReportSavingsArr: [],
	memberAccountReportFixedDepositResponse: null,
	memberAccountReportFixedDepositArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET MEMBERACCOUNT REPORT DETAILS FOR SAVINGS START *********************** */
		case MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_SUCCESS:
			return {
				...state,
				memberAccountReportSavingsResponse: action.payload,
				memberAccountReportSavingsArr: docodeHexResponse(
					action.payload,
					'GetMemberAccountReportForSavingsKey',
				),
			};
		case MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_FAILURE:
			return { ...state, memberAccountReportSavingsResponse: action.payload };

		case MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_RESPONSE_CHANGED:
			return { ...state, memberAccountReportSavingsResponse: null };
		/** ***************** GET MEMBERACCOUNT REPORT DETAILS FOR SAVINGS END *********************** */

		/** ***************** GET MEMBERACCOUNT REPORT DETAILS FOR FIXED DEPOSIT START *********************** */
		case MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_SUCCESS:
			return {
				...state,
				memberAccountReportFixedDepositResponse: action.payload,
				memberAccountReportFixedDepositArr: docodeHexResponse(
					action.payload,
					'GetMemberAccountReportForFixedDepositKey',
				),
			};
		case MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_FAILURE:
			return { ...state, memberAccountReportFixedDepositResponse: action.payload };

		case MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_RESPONSE_CHANGED:
			return { ...state, memberAccountReportFixedDepositResponse: null };
		/** ***************** GET MEMBERACCOUNT REPORT DETAILS FOR FIXED DEPOSIT END *********************** */

		default:
			return state;
	}
};
